import { supabase } from '../lib/supabase';
import { logError } from '../utils/logger';

export const sendEmail = async (type, booking) => {
  const { error } = await supabase.functions.invoke('send-email', { body: { type, booking } });
  if (error) await logError(supabase, 'email', `${type} failed: ${error.message}`, { booking_id: booking?.id });
};

export const invokeCalendar = async (action, payload, bookingId) => {
  const { data, error } = await supabase.functions.invoke('google-calendar', {
    body: { action, ...payload },
  });
  if (error) await logError(supabase, 'calendar', `Calendar ${action} failed: ${error.message}`, { booking_id: bookingId });
  return data;
};

export const processRefund = async (paymentIntentId, amount) => {
  const body = amount !== undefined
    ? { payment_intent_id: paymentIntentId, amount: Math.round(amount * 100) }
    : { payment_intent_id: paymentIntentId };
  const { error } = await supabase.functions.invoke('process-refund', { body });
  if (error) throw new Error(error.message);
};
